import {Vue} from "ui.vue";

export let CatalogMenu = {
	name: "CatalogMenu",
	data() {
		return {
			isMobile: false,// мобильное разрешение (экран меньше 768px)
			isTouch: false,// touch устройство - для переключения событий между hover и click
			loaded: false,
			loading: false,
			maxDepthLevel: 3, /* максимальный уровень вложенности */
			subItemsCount: 4, /* максимальное кол-во элементов на последнем уровне */
			TREE: {},
			treeIDS: {},
			containerSelector: ".catalog_menu"
		}
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("T_CM_");
		}
	},
	created() {
		this.containerSelector = "#" + this.templateId;
	},
	mounted() {
		this.initEvents();
	},
	methods: {
		/**
		 * Обработка результатов после успешной отправки формы
		 *
		 */
		onSuccess(data) {
			this.loading = false;
			this.loaded = true;
			this.TREE = data;

			for (let index in this.TREE) {
				if (this.TREE[index].hasOwnProperty("ITEM")
					&& this.TREE[index].ITEM.hasOwnProperty("PARAMS")
					&& this.TREE[index].ITEM.PARAMS.hasOwnProperty("ID")
					&& this.TREE[index].ITEM.PARAMS.ID
				) {
					this.treeIDS[this.TREE[index].ITEM.PARAMS.ID] = index;
				}

				if (this.TREE[index].hasOwnProperty("ITEMS")) {
					for (let subindex in this.TREE[index].ITEMS) {
						let allList = [],
							smallList = [];
						for (let i in this.TREE[index].ITEMS[subindex].ITEMS) {
							allList.push(this.TREE[index].ITEMS[subindex].ITEMS[i]);

							if (smallList.length < this.subItemsCount) {
								smallList.push(this.TREE[index].ITEMS[subindex].ITEMS[i]);
							}
						}

						this.TREE[index].ITEMS[subindex].ITEMS = smallList;
						this.TREE[index].ITEMS[subindex].ALL_ITEMS = allList;
					}
				}
			}

			setTimeout(() => {
				this.checkIsMobile();
				this.toggleMenuItems();
			}, 100);
		},

		/**
		 * Обработка ошибок при отправке данных формы
		 *
		 * @param {Error|Array|string} error
		 */
		onError(error) {
			this.loading = false;
			this.loaded = true;
			console.error(error);
		},
		loadSubMenu() {
			if (this.loaded || this.loading) {
				return;
			}

			let formData = new FormData();
			formData.append("signedParameters", this.signedParameters)

			this.loading = true;
			this.$request
				.setOption({
					componentName: this.componentName,
					action: this.action
				})
				.setSignedParameters(this.signedParameters)
				.setData(formData)
				.send().then(this.onSuccess, this.onError);
		},
		initEvents() {
			this.toggleMenuWrap(this.containerSelector + " .catalog_title", "catalog_menu-open", true);

			this.checkIsMobile();
			this.toggleMenuItems();

			$(window).resize(() => {
				this.checkIsMobile();
				this.toggleMenuItems();
			});
		},
		checkIsMobile() {
			this.isMobile = window.innerWidth <= 991;
			this.isTouch = this.isMobile || (!this.isMobile && $("html").hasClass("bx-touch"));

			/**
			 * Для десктоп версии динамически высчитывать высоту
			 */
			if (!this.isMobile) {
				let menuHeight = $(".header").outerHeight(); // высота шапки

				$(this.containerSelector + " .submenu_sections._lvl2").css({"max-height": "calc(100vh - " + menuHeight + "px)"});

				let minHeight = 0;// общая высота пунктов левого меню
				$(this.containerSelector + " ._lvl1 > ul").children().each(function () {
					minHeight += $(this).outerHeight();
				});
				$(this.containerSelector + " .submenu_sections._lvl2").css({"min-height": minHeight + "px"});// устанавливаем отдельно, чтобы получить актуальную высоту
			} else {
				$(this.containerSelector + " .submenu_sections._lvl2").css({"max-height": "", "min-height": ""});
			}
		},
		toggleMenuItems() {
			if (this.isTouch) {
				$(this.containerSelector + ' li.parent .icon').off("click").on("click", (event) => {
					let currentEl = $(event.currentTarget);
					event.preventDefault();

					$(this.containerSelector + ' .catalog_menu_wr').addClass('open');

					currentEl.closest('li.parent').siblings().each(function () {
						$(this).removeClass('active');
					});

					currentEl.closest('.item_list').siblings().each(function () {
						$(this).removeClass('active');
						$(this).find('.active').removeClass('active');
					});
					this.openSubmenu(currentEl);

					currentEl.closest('li.parent').addClass('active');
				});
				$('.overlay').on('click', function () {
					$(this.containerSelector + ' .catalog_menu_wr').removeClass('open');
					$(this.containerSelector + ' .catalog_menu_wr').find('.active').removeClass('active');
					$('html').removeClass('hover_catalog_menu');
				});
			} else {
				$(this.containerSelector + ' ._lvl1 ul li.parent').off("mouseover").on('mouseover', (event) => {
					let currentEl = $(event.currentTarget);
					if (currentEl.closest('.catalog_mobile_hot').length || currentEl.closest('.catalog_section').length) {
						return;
					}

					this.openSubmenu(currentEl);
				});
			}

			$(this.containerSelector + ' .item_list .back, .b-catalogMenu_mobile .item_list .back').off("click").on("click", function () {
				$(this).closest('.submenu_sections').removeClass('active');
			});
		},
		openSubmenu(event) {
			var section = event.closest('li.parent'),
				sectionId = section.data('id'),
				submenuSections = event.closest('.catalog_menu_wr').find('.submenu_sections');

			if (!section.closest('.submenu_sections').length) {
				section.addClass("active");
			}

			let that = this;
			submenuSections.each(function () {
				if ($(this).data('list-id') == sectionId) {
					$(this).addClass("active");
					$(this).find(".lazyLoad-in-view").trigger("inView");
					if (that.isTouch) {
						that.$el.scrollTo(0, 0);//скролл к началу списка пунктов для мобильных
					}
				}
			});

			this.loadSubMenu();

			if (!this.isTouch) {
				$('html').addClass('hover_catalog_menu');
			}
		},
		onMouseOut(event) {
			let currentEl = $(event.currentTarget),
				submenuSectionsActive = currentEl.find('.submenu_sections.active');

			if (!submenuSectionsActive.length) {
				currentEl.find('.active').removeClass('active');
				$('html').removeClass('hover_catalog_menu');
			} else {
				for (let i = 2; i <= this.maxDepthLevel; i++) {
					submenuSectionsActive = currentEl.find('.submenu_sections._lvl' + i + '.active');

					if (submenuSectionsActive.hasClass('_lvl' + i)) {
						if (!$(event.relatedTarget).closest('.submenu_sections._lvl' + i + '.active').length
							&& !$(event.relatedTarget).hasClass('submenu_sections')) {
							submenuSectionsActive.removeClass('active');
						}
					}
				}

				if (!currentEl.find('.submenu_sections.active').length) {
					currentEl.find('.active').removeClass('active');
					$('html').removeClass('hover_catalog_menu');
				}
			}
		},
		toggleMenuWrap(element, htmlClass, scroll) {
			/* open menu */
			$(element).on("click", () => {
				var elementPosition = $(element).offset().top;
				$("html").toggleClass(htmlClass);
				if (scroll) {
					$("body,html").animate({scrollTop: elementPosition}, 500);
				}
			});

			/* hide menu */
			$(".overlay").on("click", () => {
				$("html").removeClass(htmlClass);
			});
		}
	}
}

export default {CatalogMenu};
